import { useCallback } from "react";
import { useIonLoading, useIonToast } from "@ionic/react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { cancelFreeSubscription } from "../redux/actions";
import { refreshAfterFreeTrialChange } from "../services/freeTrialRefresh";

// "Annulla la prova": cancel, reload everything that shows the FREE status, then
// land on the Dashboard already up to date. One implementation for every screen
// with the link — the three copies had drifted (one never cleared the calendar
// cache) and none reset the throttled profile fetch.
export const useCancelFreeTrial = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [ionLoading, hideIonLoading] = useIonLoading();
  const [toast] = useIonToast();

  return useCallback(async () => {
    ionLoading();
    try {
      const result = await dispatch(cancelFreeSubscription()).unwrap();
      await refreshAfterFreeTrialChange(dispatch);
      history.replace("/home");
      toast({
        message: result?.message ?? "Prova gratuita annullata.",
        duration: 3000,
      });
    } catch (err) {
      toast({
        message: err?.message ?? "Errore durante l'annullamento della prova.",
        duration: 3000,
        color: "danger",
      });
    } finally {
      hideIonLoading();
    }
  }, [dispatch, history, ionLoading, hideIonLoading, toast]);
};
